import { render, staticRenderFns } from "./officialAccountCard.vue?vue&type=template&id=bdcee270"
import script from "./officialAccountCard.vue?vue&type=script&lang=ts"
export * from "./officialAccountCard.vue?vue&type=script&lang=ts"
import style0 from "./officialAccountCard.vue?vue&type=style&index=0&id=bdcee270&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports